import { IRoute } from "@delanobgt/admin-core/util/types";
import { lazy } from "react";

const Login = lazy(() => import("src/pages/Auth/Login"));

export type TLoginRouteNames = "LOGIN";

export const loginRoutes: Record<TLoginRouteNames, IRoute> = {
  LOGIN: {
    Icon: null,
    path: "/login",
    Page: Login,
  },
};
